import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { StoreFlag } from "../../../_model/store-response/store-flag";
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
@Component({
  selector: 'app-store-flag',
  templateUrl: './store-flag.component.html',
  standalone: true,
  imports: [MatSlideToggleModule, ReactiveFormsModule, FormsModule, MatButtonModule, MatInputModule],
  styleUrls: ['./store-flag.component.scss']
})
export class StoreFlagComponent implements OnInit, OnChanges {

  @Input() header: string = '';
  @Input() formGroup!: FormGroup;
  @Input() ctrlArrayName: string = '';
  @Input() flags!: StoreFlag[];
  @Input() disableStore: boolean = false;
  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['disableStore'] && this.formGroup) {
      const ctrlArray = this.formGroup.get(this.ctrlArrayName) as FormArray;
      if (ctrlArray) {
        if (this.disableStore) {
          ctrlArray.disable({ emitEvent: false });
        } else {
          ctrlArray.enable({ emitEvent: false });
        }
      }
    }
  }

  public get ctrlArray() {
    return this.formGroup.get(this.ctrlArrayName) as FormArray;
  }

}
